import { render, staticRenderFns } from "./ChecksBarChart.vue?vue&type=template&id=2aa5498e&scoped=true&"
import script from "./ChecksBarChart.vue?vue&type=script&lang=js&"
export * from "./ChecksBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ChecksBarChart.vue?vue&type=style&index=0&id=2aa5498e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5498e",
  null
  
)

export default component.exports